























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsIdProvider} from "@/api/tsclient";
import {rolesModule, usersModule} from "@/store";
import UserDto = MdbsIdProvider.UserDto;

@Component({})
export default class UserDialog extends Vue {
  @Prop({required: true})
  show!: boolean;

  @Prop({required: true})
  user!: UserDto;

  userName?: string | undefined;
  displayName?: string | undefined;
  email?: string | undefined;
  roleId?: string | undefined;
  passwordString?: string | undefined;

  valid: boolean = false;
  loading: boolean = false;

  rules: any = {
    required: (v: string) => !!v || 'Wird benötigt',
    validUserName: (v: any) => !v || /^[0-9a-zA-Z_.-]+$/.test(v) ||
        "Benutzername darf nur Zeichen wie 'A-Z', '0-9', '_' oder '-' enthalten",
    email: (v: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(v) || 'Ungültige Emailaddresse'
    },
    min: (v: any) => v.length >= 6 || 'Mindestens 6 Zeichen',
    uppercase: (v: any) => (/[A-Z]/.test(v)) || 'Mindestens 1 Großbuchstaben',
    lowercase: (v: any) => (/[a-z]/.test(v)) || 'Mindestens 1 Kleinbuchstabe',
    number: (v: any) => (/[0-9]/.test(v)) || 'Mindestens eine Zahl',
    nonAlphanumeric: (v: any) => (/[\W]/.test(v)) || 'Mindestens ein nicht-alphanumerisches Zeichen'
  };

  get roles() {
    return rolesModule.roles;
  }

  async mounted() {
    this.loading = true;
    await rolesModule.loadAll();
    this.loading = false;
  }

  @Watch('user', {
    immediate: true
  })
  onUserChanged(user: UserDto | null) {
    if (!user)
      return;
    this.userName = user.userName
    this.displayName = user.displayName
    this.email = user.email
    this.roleId = user.role?.id
    this.passwordString = ""
  }

  async save() {
    try {
      this.loading = true;
      if (!this.user.id) {
        await usersModule.createUser({
          userName: this.userName ?? "",
          displayName: this.displayName ?? "",
          email: this.email ?? "",
          passwordString: this.passwordString ?? "",
          roleId: this.roleId ?? "",
          emailConfirmed: this.email != null,
          isDeleted: false,
          noLogin: false,
        });
      } else {
        await usersModule.updateUser({
          id: this.user.id,
          userName: this.userName ?? "",
          displayName: this.displayName ?? "",
          email: this.email ?? "",
          roleId: this.roleId ?? "", // TODO Check if this should be the ID
          emailConfirmed: this.email != null,
          isDeleted: false,
          noLogin: false,
        });
      }
      this.$emit('confirm')
    } catch (e) {
      console.error("editing realPatient failed", e)
    } finally {
      this.loading = false;
    }
  }
}
